import FingerprintJS from "@fingerprintjs/fingerprintjs";
export async function getDeviceId() {
  // 1️⃣ Check if we already stored a stable device ID before
  let savedId = localStorage.getItem("stableDeviceId");
  if (savedId) return savedId;

  // 2️⃣ Generate FingerprintJS ID first
  const fp = await FingerprintJS.load();
  const r = await fp.get();
  const visitorId = r.visitorId;

  // 3️⃣ Save it permanently so it NEVER changes again
  localStorage.setItem("stableDeviceId", visitorId);

  return visitorId;
}


// Get Local IP (WebRTC)
async function getLocalIP() {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    return data.ip || "UnknownIP";
  } catch {
    return "UnknownIP";
  }
}

// Detect Device Type
function getDeviceType() {
  if (/Mobi|Android/i.test(navigator.userAgent)) return "Mobile";
  if (/Tablet|iPad/i.test(navigator.userAgent)) return "Tablet";
  return "Desktop";
}

// Detect OS
function getOS() {
  const ua = navigator.userAgent;

  if (ua.includes("Win")) return "Windows";
  if (ua.includes("Mac")) return "MacOS";
  if (ua.includes("Linux")) return "Linux";
  if (/Android/i.test(ua)) return "Android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
  return "UnknownOS";
}

// Detect Browser
function getBrowser() {
  const ua = navigator.userAgent;

  if (ua.includes("Chrome")) return "Chrome";
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("Safari")) return "Safari";
  if (ua.includes("Edg")) return "Edge";
  return "UnknownBrowser";
}

// 🚀 FINAL READABLE DEVICE NAME GENERATOR
export async function getReadableDeviceName() {
  const ip = await getLocalIP();
  const os = getOS();
  const browser = getBrowser();
  const type = getDeviceType();

  return `${browser}${type}-${os}`;
}
